import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Spinner, Alert } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';
import './BlogPostPage.css'; // Uvoz naše nove CSS datoteke

const BlogPostPage = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/blog/${slug}`);
                if (!response.ok) throw new Error('Objava ni bila najdena.');
                const data = await response.json();
                setPost(data);
            } catch (err) {
                setError('Prišlo je do napake pri nalaganju objave.');
            } finally {
                setLoading(false);
            }
        };
        fetchPost();
    }, [slug]);

    if (loading) return (
        <div className="loading-spinner">
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Nalaganje...</span>
            </Spinner>
        </div>
    );
        
    if (error) return (
        <Container className="error-alert">
            <Alert variant="danger">{error}</Alert>
        </Container>
    );

    if (!post) return null;

    return (
        <Container className="blog-post-container">
            <header className="blog-post-header">
                <h1 className="blog-post-title">{post.title}</h1>
                <p className="blog-post-meta">
                    Avtor: {post.author.username} | Objavljeno: {new Date(post.created_at).toLocaleDateString('sl-SI')}
                </p>
            </header>
            
            <hr className="separator" />

            <article className="blog-post-content">
                <div className="ql-snow">
                    <div className="ql-editor" dangerouslySetInnerHTML={{ __html: post.content }} />
                </div>
            </article>
        </Container>
    );
};

export default BlogPostPage;